// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { CommandRule, CommandRuleT } from "./command-rule";
import { IgnoreRule, IgnoreRuleT } from "./ignore-rule";
import { TransformRule, TransformRuleT } from "./transform-rule";

export enum OutRule {
  NONE = 0,
  IgnoreRule = 1,
  CommandRule = 2,
  TransformRule = 3,
}

export function unionToOutRule(
  type: OutRule,
  accessor: (
    obj: CommandRule | IgnoreRule | TransformRule,
  ) => CommandRule | IgnoreRule | TransformRule | null,
): CommandRule | IgnoreRule | TransformRule | null {
  switch (OutRule[type]) {
    case "NONE":
      return null;
    case "IgnoreRule":
      return accessor(new IgnoreRule())! as IgnoreRule;
    case "CommandRule":
      return accessor(new CommandRule())! as CommandRule;
    case "TransformRule":
      return accessor(new TransformRule())! as TransformRule;
    default:
      return null;
  }
}

export function unionListToOutRule(
  type: OutRule,
  accessor: (
    index: number,
    obj: CommandRule | IgnoreRule | TransformRule,
  ) => CommandRule | IgnoreRule | TransformRule | null,
  index: number,
): CommandRule | IgnoreRule | TransformRule | null {
  switch (OutRule[type]) {
    case "NONE":
      return null;
    case "IgnoreRule":
      return accessor(index, new IgnoreRule())! as IgnoreRule;
    case "CommandRule":
      return accessor(index, new CommandRule())! as CommandRule;
    case "TransformRule":
      return accessor(index, new TransformRule())! as TransformRule;
    default:
      return null;
  }
}

export type OutRuleT =
  | { type: "NONE"; value: null }
  | { type: "IgnoreRule"; value: IgnoreRuleT }
  | { type: "CommandRule"; value: CommandRuleT }
  | { type: "TransformRule"; value: TransformRuleT };
